import { useState, useEffect, useRef } from "react";
import { useAppSelector } from "src/store/hooks";
import moment from "moment";

type TimerType = {
  fromTimestamp?: number | null;
};

export default function Timer({ fromTimestamp }: TimerType) {
  const { globalTimer } = useAppSelector((state) => state.timer);

  const [showTimer, setTimer] = useState("00:00:00");
  const initialTimestamp = useRef(fromTimestamp || new Date().getTime());

  useEffect(() => {
    if (fromTimestamp) initialTimestamp.current = fromTimestamp;
  }, [fromTimestamp]);

  // Update timer
  useEffect(() => {
    const end = moment();
    const start = moment(initialTimestamp.current);
    const duration = moment.duration(end.diff(start));

    const hours = duration.hours().toString().padStart(2, "0");
    const minutes = duration.minutes().toString().padStart(2, "0");
    const seconds = duration.seconds().toString().padStart(2, "0");

    setTimer(`${hours}:${minutes}:${seconds}`);
  }, [globalTimer]);

  return <span>{showTimer}</span>;
}
